import { StyleOptions } from '@frontend/loaders';
import { ClientConfigProductName } from '@frontend/vanilla/core';

const defaultStyle = { id: 'sports-top-events', type: 'theme' } as StyleOptions;

export const TopEventsLoader = {
    id: 'top-events',
    loaderFn: () => import(/* webpackChunkName: "ms-top-events" */ './top-events.feature'),
    additionalStylesFn: (): StyleOptions[] => [defaultStyle],
    product: ClientConfigProductName.SPORTS,
};
